import { Box, Paper, Typography } from "@mui/material";

import React from "react";
import SimpleTable from "./SimpleTable";

interface TableWrapperWithPageHeaderProps {
  title?: string;
  subtitle?: string;
  columns: any;
  rows: any[];
  rowsPerPage: number;
  page: number;
  handleChangePage: (event: unknown, newPage: number) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  paddingTop?: string;
  paddingBottom?: string;
}

const TableWrapperWithPageHeader: React.FC<TableWrapperWithPageHeaderProps> = ({
  title = "",
  subtitle = "",
  columns = [],
  rows = [],
  rowsPerPage = 10,
  page = 0,
  handleChangePage = () => {},
  handleChangeRowsPerPage = () => {},
  paddingTop = "14px",
  paddingBottom = "14px",
}) => {
  return (
    <Paper
      sx={{ width: "100%", overflow: "hidden", padding: "0 16px 4px 16px" }}
    >
      {(title || subtitle) && (
        <Box sx={{}} paddingY={2}>
          {title && (
            <Typography variant="h5" fontWeight={600}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ letterSpacing: "0.17px" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      <SimpleTable
        columns={columns}
        rows={rows}
        rowsPerPage={rowsPerPage}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TableWrapperWithPageHeader;
